module.exports = __webpack_public_path__ + "static/media/slide2.1d2694ca.png";